module.exports = __webpack_public_path__ + "static/img/pflogo.1a5bd41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/pflogo.png
// module id = 4x68
// module chunks = 0